import { currentPageNameDuck } from '@/ducks';

export default function withCurrentPageName() {
    return async (ctx) => ctx.store.dispatch(currentPageNameDuck.creators.set(ctx.pageName));
}
